import { render, staticRenderFns } from "./CtrlBox.vue?vue&type=template&id=4574707f&"
import script from "./CtrlBox.vue?vue&type=script&lang=js&"
export * from "./CtrlBox.vue?vue&type=script&lang=js&"
import style0 from "./CtrlBox.vue?vue&type=style&index=0&id=4574707f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports